import styled from 'styled-components';

import { BoxStyledArgs } from './index';

export const StyledBox = styled.div<BoxStyledArgs>`
    ${({ $withShadow }) => $withShadow && 'box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.12);'};
    ${({ $borderRadius }) => $borderRadius && `border-radius: ${$borderRadius}px;`};
    ${({ $mb }) => $mb && `margin-bottom: ${$mb}px;`};
    ${({ theme, $backgroundColor }) => $backgroundColor && `background-color: ${theme[$backgroundColor]};`};
    ${({ theme, $borderColor }) => $borderColor && `border: 1px solid  ${theme[$borderColor]};`};

    ${({ $paddingTop }) => Boolean($paddingTop) && `padding-top: ${$paddingTop}px;`};
    ${({ $paddingX }) => Boolean($paddingX) && `padding-left: ${$paddingX}px; padding-right: ${$paddingX}px;`};

    ${({ $paddingBottom }) => Boolean($paddingBottom) && `padding-bottom: ${$paddingBottom}px;`};
`;
